<template>
	<!-- Date d'acte ou période d'une ou plusieurs lignes. Une date d'acte s'enregistre en période d'un
	     jour : début et fin égaux. -->
	<div class="invoice-supplier-date-editor">
		<strong v-if="title" class="invoice-supplier-date-editor__title">{{ title }}</strong>

		<b-button-group size="sm">
			<b-button :variant="mode === 'act' ? 'dark' : 'outline-secondary'" :pressed="mode === 'act'" @click="mode = 'act'">{{ $t('invoice.supplier_details_date_mode_act') }}</b-button>
			<b-button :variant="mode === 'period' ? 'dark' : 'outline-secondary'" :pressed="mode === 'period'" @click="mode = 'period'">{{ $t('invoice.supplier_details_date_mode_period') }}</b-button>
		</b-button-group>

		<div class="invoice-supplier-date-editor__field">
			<span class="invoice-supplier-details__field-label">{{ $t(mode === 'act' ? 'invoice.supplier_details_date_on' : 'invoice.supplier_details_date_from') }}</span>
			<e-datepicker v-model="start" />
		</div>

		<div v-if="mode === 'period'" class="invoice-supplier-date-editor__field">
			<span class="invoice-supplier-details__field-label">{{ $t('invoice.supplier_details_date_to') }}</span>
			<e-datepicker v-model="end" :min-date="start" />
		</div>

		<div class="invoice-supplier-date-editor__actions">
			<button type="button" class="btn btn-primary btn-sm" :disabled="!valid" @click="$emit('apply', range)">{{ $t('invoice.supplier_details_date_apply') }}</button>
			<button v-if="groupSize > 1" type="button" class="btn btn-secondary btn-sm" :disabled="!valid" @click="$emit('apply-group', range)">
				{{ $t('invoice.supplier_details_date_apply_group', { count: groupSize }) }}
			</button>
			<button type="button" class="btn btn-secondary btn-sm" @click="$emit('apply', { start: null, end: null })">{{ $t('invoice.supplier_details_date_clear') }}</button>
			<button type="button" class="btn btn-link btn-sm" @click="$emit('cancel')">{{ $t('global.annuler') }}</button>
		</div>
	</div>
</template>


<script type="text/javascript">
	export default {
		name: "InvoiceSupplierLineDateEditor",

		props: {
			// Dates de départ, au format AAAA-MM-JJ, ou null.
			startDate: { type: String, default: null },
			endDate: { type: String, default: null },
			// Nombre de lignes de l'intercalaire de la ligne éditée : au-delà d'une, la date peut s'y
			// appliquer d'un geste.
			groupSize: { type: Number, default: 0 },
			title: { type: String, default: null }
		},

		data() {
			return {
				// Une période d'un seul jour est une date d'acte.
				mode: this.startDate && this.endDate && this.endDate !== this.startDate ? 'period' : 'act',
				start: this.parseDate(this.startDate),
				end: this.parseDate(this.endDate)
			}
		},

		computed: {
			/**
			 * Dates à déposer sur les lignes, au format de l'API.
			 */
			range() {
				const start = this.toYmd(this.start)

				if(this.mode === 'act') return { start, end: start }

				return { start, end: this.toYmd(this.end) }
			},

			/**
			 * Une période se ferme, et ne finit pas avant d'avoir commencé.
			 */
			valid() {
				if(!this.start) return false
				if(this.mode === 'act') return true

				return !!this.end && this.end >= this.start
			}
		},

		methods: {
			/**
			 * Date au format AAAA-MM-JJ, lue en heure locale : toDateInputValue() passe par l'UTC et rend la
			 * veille d'une date saisie à minuit à l'est de Greenwich.
			 *
			 * @param {Date|null} date
			 * @return {String|null}
			 */
			toYmd(date) {
				if(!date) return null

				return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-')
			},

			/**
			 * Date locale d'une date AAAA-MM-JJ : new Date() la lirait à minuit UTC, la veille à l'ouest
			 * de Greenwich.
			 */
			parseDate(value) {
				if(!value) return null

				const [year, month, day] = value.split('-').map(Number)

				return new Date(year, month - 1, day)
			}
		}
	}
</script>
